import { cn } from "@/lib/utils";

const STATUS_STYLES = {
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  requested: "bg-amber-50 text-amber-700 border-amber-200",
  awaiting_landlord: "bg-blue-50 text-blue-700 border-blue-200",
  awaiting_renter: "bg-blue-50 text-blue-700 border-blue-200",
  pending_signature: "bg-amber-50 text-amber-700 border-amber-200",
  open: "bg-amber-50 text-amber-700 border-amber-200",
  in_progress: "bg-blue-50 text-blue-700 border-blue-200",
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  confirmed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  signed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  resolved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rejected: "bg-red-50 text-red-700 border-red-200",
  declined: "bg-red-50 text-red-700 border-red-200",
  ended: "bg-stone-200 text-stone-600 border-stone-300",
  urgent: "bg-red-50 text-red-700 border-red-200",
  medium: "bg-amber-50 text-amber-700 border-amber-200",
  low: "bg-stone-100 text-stone-600 border-stone-200",
};

export function StatusBadge({ status, className, testid }) {
  const label = String(status || "").replace(/_/g, " ");
  return (
    <span
      data-testid={testid}
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold border capitalize",
        STATUS_STYLES[status] || "bg-stone-100 text-stone-600 border-stone-200",
        className
      )}
    >
      {label}
    </span>
  );
}

export function EmptyState({ icon: Icon, title, subtitle, action }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6">
      {Icon && (
        <div className="h-14 w-14 rounded-2xl bg-bone flex items-center justify-center mb-4">
          <Icon className="h-7 w-7 text-forest" strokeWidth={1.75} />
        </div>
      )}
      <h3 className="text-lg font-heading font-medium text-ink">{title}</h3>
      {subtitle && <p className="text-sm text-mute mt-1 max-w-sm">{subtitle}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function Overline({ children }) {
  return (
    <span className="text-xs font-bold uppercase tracking-[0.2em] text-forest">
      {children}
    </span>
  );
}
